import { ErrorBoundary } from '@sentry/react'

const Boundary = (props) => {
    return (
        <ErrorBoundary
            fallback={
                <h1>
                    We couldn't load Backstage, please try refreshing this page
                </h1>
            }
        >
            {props.children}
        </ErrorBoundary>
    )
}

export default Boundary
